<h3 mat-dialog-title [ngStyle]="{'color': farmTypeColor, 'margin': '0px 0 2px'}">Refinery processing is complete</h3>

<div mat-dialog-content>
  <div>
    <table class="styled-table" style="width: 50%;">
      <tr align="left" style="font-size: 10px;"  class="header_row">
        <td style="width:150px; font-weight: bold;">Processing Time</td>
        <td style="width:79px; font-weight: bold;" >{{totalTimeTaken}}</td>
      </tr>
      <tr align="left" style="font-size: 10px;">
        <td style="width:150px;">Nodes Completed</td>
        <td style="width:79px;" >{{successCount}}</td>
      </tr>
      <tr align="left" style="font-size: 10px;">
        <td style="width:150px;">Nodes Failed</td>
        <td style="width:79px;" >{{errorCount}}</td>
      </tr>
      <tr align="left" style="font-size: 10px;">
        <td style="width:150px;">Nodes Not Run</td>
        <td style="width:79px;" >{{notRunCount}}</td>
      </tr>
    </table>
    <span>
      <button (click)="toggleDetails()" mat-raised-button tabindex="-1" class="button-spacing">Details</button>
    </span>
  </div>
  
  <div *ngIf="detailsVisible">
    <table >
      <tr class="header_row" align="left" >
        <td >Node Location</td>
        <td >Order</td>
        <td >Node Name</td>
        <td >Node Type</td>
        <td >Farm Type</td>
        <td >Transformers</td>
        <td >Status</td>
        <td >Processing Time</td>
      
      </tr>
 
      <ng-container *ngFor="let row of summaryData">
        <tr style="font-size: 10px;">
          <td>{{ row.rcNo }}</td>
          <td>{{ row.order }}</td>
          <td>{{ row.label }}</td>
          <td>{{ row.nodeBoxName }}</td>
          <td>{{ row.farmName }}</td>
          <td>{{ row.transformers }}</td>
          <td  [ngStyle]="{'color': NodeRunStatusUtil.statusColor(row.statusCode)}">  {{ NodeRunStatusUtil.toString( row.statusCode) }}</td>
          <td>{{ row.timeTaken }}</td>
        
        </tr>
      </ng-container>
    </table>
  </div>
</div>

<mat-dialog-actions align="end">
  <button (click)="cancel()" mat-raised-button mat-dialog-close tabindex="-1">Close</button>
</mat-dialog-actions>
